import React from 'react';
import {useSelector} from 'react-redux';


import {setupDataSelector} from 'src/modules/profile/account/tabs/admin-account-api-v2/views/controllers/setup/services/selectors';

import Loading from '@pb/kit-component-loading';

import {usePricingSubscriptions} from './hooks';
import {contractsDataSelector} from './services/selectors';
import {PricingView} from './views/pricing.view';

import type {ParseContracts} from '../contracts/parse-contracts';

export const PricingController = () => {
    usePricingSubscriptions();

    const setupData = useSelector(setupDataSelector);
    const contractsData: ParseContracts | null = useSelector(contractsDataSelector);

    return contractsData && setupData ? <PricingView/> : <Loading/>;
};
